import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { TShirtSizesFormComponentDeprecated } from './t-shirt-sizes-form-component-deprecated.component';
import { TShortSizeSelectBoxModule } from '../t-short-size-select-box/t-short-size-select-box.module';
import { TShirtSizesFormServiceDeprecated } from './t-shirt-sizes-form-service-deprecated.service';

/**
 * @deprecated Use TShirtSizesFormModule instead
 */
@NgModule({
  declarations: [TShirtSizesFormComponentDeprecated],
  imports: [CommonModule, SharedModule, TShortSizeSelectBoxModule],
  exports: [TShirtSizesFormComponentDeprecated],
  providers: [TShirtSizesFormServiceDeprecated],
})
export class TShirtSizesFormModuleDeprecated {}
